module.exports = __webpack_public_path__ + "static/media/android.dfd595f0.svg";